import clsx from "clsx";
import React from "react";

const StatusBadge: React.FC<{ label: string; statusFillClassname?: string; colorClassName?: string }> = ({
  label,
  colorClassName,
  statusFillClassname,
}) => {
  return (
    <span
      className={clsx(
        "inline-flex items-center gap-x-1.5 rounded-full  px-1.5 py-0.5 text-xs font-medium ring-1 ring-current ",
        colorClassName ? colorClassName : "bg-gray-100 text-gray-600",
      )}
    >
      <svg
        className={clsx("h-1.5 w-1.5 ", statusFillClassname ? statusFillClassname : "fill-gray-400")}
        viewBox="0 0 6 6"
        aria-hidden="true"
      >
        <circle cx={3} cy={3} r={3} />
      </svg>
      {label}
    </span>
  );
};

export default StatusBadge;
